import React from 'react';
import { bool, func } from 'prop-types';

import { ProDropdown } from './ProDropdown';

export const FiverrPro = ({ isTransparent, onOpen }) => {
    const commonDropdownProps = {
        isTransparent,
        onOpen,
    };

    return <ProDropdown {...commonDropdownProps} />;
};

FiverrPro.propTypes = {
    isTransparent: bool,
    onOpen: func,
};
